import React from 'react';
import PropTypes from 'prop-types';
import { Wizard as WizardComponent } from 'react-use-wizard/dist/index';

function Wizard ({ header, footer, children }) {
  return (
    <WizardComponent
      header={header}
      footer={footer} >
      {children}
    </WizardComponent>
  );
}

export default Wizard;

Wizard.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.node,
  footer: PropTypes.node
};
